import { useCallback, useEffect } from 'react';
import { usePusher } from 'context/pusher';

const usePusherEvent = (channel, eventName, callback, ...deps) => {
  const { channels } = usePusher();
  const c = channels[channel];
  const memoizedCallback = useCallback(callback, deps);
  useEffect(() => {
    if (!c) return;
    c.bind(eventName, callback);
    return () => {
      c.unbind(eventName, callback);
    };
  }, [eventName, channel, c, memoizedCallback]);
  return c;
};

export default usePusherEvent;
